import { render } from "./SortBy.vue?vue&type=template&id=799c22d5&scoped=true"
import script from "./SortBy.vue?vue&type=script&lang=js"
export * from "./SortBy.vue?vue&type=script&lang=js"

import "./SortBy.vue?vue&type=style&index=0&id=799c22d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799c22d5"]])

export default __exports__